"use strict";
var Observable_1 = require("../../Observable");
var publishReplay_1 = require("../../operator/publishReplay");
Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
//# sourceMappingURL=publishReplay.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/publishReplay.js
 ** module id = 363
 ** module chunks = 1
 **/